import readings from './begijnhofRows.json';
import type { BuildContext } from '../../types';
import type { PolygonIndex } from '../../../geo/polygonIndex';
import type { ReservedFootprint } from '../types';
import { surveyedRowLots } from './rowLots';
import type { SurveyedRow } from './rowTypes';

export const BEGIJNHOF_ROWS = readings.rows as unknown as readonly SurveyedRow[];

/**
 * The hof's ground between its paths and the Nieuwezijds Voorburgwal. The quay along that water
 * would front it with houses of its own before the hof's row is planned, and the woodcut draws the
 * strip toward the Spui open; the paths and the quay bound it, they are not property lines.
 */
export function begijnhofReservation(layout: BuildContext['layout']): ReservedFootprint | null {
  const find = (id: string) => layout.streets.find((s) => s.id === id)?.centerline;
  const court = find('street-begijnhof'),
    south = find('street-begijnhof-2'),
    quay = find('quay-nieuwezijds-voorburgwal-2');
  if (!court || !south || !quay || court.length < 2 || south.length < 3 || quay.length < 2)
    return null;
  return {
    id: 'surveyed-begijnhof-west',
    polygon: {
      outer: [...quay.slice(0, -1), ...south.slice(-3).reverse(), court[1]],
      holes: [],
    },
  };
}

export function planBegijnhof(
  ctx: Pick<BuildContext, 'layout' | 'site'>,
  buildable: PolygonIndex,
  reserved: readonly ReservedFootprint[]
) {
  const block = begijnhofReservation(ctx.layout);
  if (!block) return { lots: [], reserved: [], unresolved: [] };
  const lots = surveyedRowLots(BEGIJNHOF_ROWS, ctx.layout, buildable, reserved, 54_000);
  const built = new Set(lots.map((l) => l.reconstruction!.id));
  const footprints = lots.map((l): ReservedFootprint => ({
    id: `surveyed:${l.reconstruction!.id}`,
    polygon: { outer: [...l.corners], holes: [] },
  }));
  return {
    lots,
    reserved: [block, ...footprints],
    unresolved: BEGIJNHOF_ROWS.flatMap((r) => r.houses.map((h) => h.id)).filter(
      (id) => !built.has(id)
    ),
  };
}
